<template>
    <div class="trainer-course">
        <div class="trainer-course-select">
            <el-select v-model="form.storeId" :placeholder="$t('Common.all_store2')">
                <el-option
                    v-for="item in stores"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id" />
            </el-select>
            <el-select
                @change="searchText = null"
                v-model="form.coachId"
                :placeholder="this.$t('Common.all_coath')">
                <input
                    class="search-input-all"
                    type="text"
                    v-model="searchText"/>
                <el-option
                    v-for="item in filterList"
                    :key="item.id"
                    :label="item.nickname"
                    :disabled="item.id === 'no'"
                    :value="item.id" />
            </el-select>
            <el-date-picker
                v-model="date"
                :clearable="false"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('Common.start_time')"
                :end-placeholder="$t('Common.end_time')" />
            <el-button
                type="primary"
                @click="fetchData(1)">
                {{ $t('Common.search_cha') }}
            </el-button>
            <el-button @click="handleReset()">{{ $t('Common.clear') }}</el-button>
        </div>
        <div class="trainer-course-tip">
            {{ $t('Week.refresh_time') }}
        </div>
         <div class="trainer-course-tabel">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="coachName" :label="$t('Coach.name_personal')"></el-table-column>
                <el-table-column prop="storeName" :label="$t('Common.store')"></el-table-column>
                <el-table-column prop="coachLevel" :label="$t('Coach.level')"></el-table-column>
                <el-table-column prop="lessonName" :label="$t('Course.name')"></el-table-column>
                <el-table-column :label="$t('Coach.charge_lesson')">
                    <el-table-column prop="levelOneLesson" :label="$t('Coach.one')"></el-table-column>
                    <el-table-column prop="levelTwoLesson" :label="$t('Coach.two')"></el-table-column>
                    <el-table-column prop="levelThreeLesson" :label="$t('Coach.three')"></el-table-column>
                    <el-table-column prop="levelFourLesson" :label="$t('Coach.four')"></el-table-column>
                    <el-table-column prop="levelFiveLesson" :label="$t('Coach.fifth')"></el-table-column>
                    <el-table-column prop="czCardLesson" :label="$t('Card.card1')"></el-table-column>
                    <el-table-column prop="totalChangeableLesson" :label="$t('Coach.lesson_all')"></el-table-column>
                </el-table-column>
                <el-table-column :label="$t('Coach.free')">
                    <el-table-column prop="freeLessonClient" :label="$t('Lesson.count')"></el-table-column>
                    <el-table-column prop="freeLessonCount" :label="$t('Stats.Enter.lesson')"></el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            v-if="tableData.length"
            class="text-right mt-8"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total">
        </el-pagination>
    </div>
</template>
<script>
import { DatePicker } from 'element-ui';

export default {
    name: 'trainer-course',
    components: {
        ElDatePicker: DatePicker,
    },
    data() {
        return {
            form: {
                storeId: '',
                coachId: '',
            },
            pagination: {
                size: 20,
                total: 0,
                page: 1,
            },
            date: [],
            tableData: [],
            stores: [],
            coachs: [],
            searchText: '',
        };
    },
    computed: {
        filterList() {
            if (!this.searchText) return this.coachs;
            const arr = this.coachs.filter(item =>
                item.nickname.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            return arr.length ? arr : [{id: 'no', nickname: this.$t('Common.data_not_found')}];
        },
    },
    created() {
        const today = new Date();
        const begin = today.setTime(today.getTime() - 3600 * 1000 * 24 * 31);
        this.date = [begin, new Date()];
        this.fetchStore();
        this.fetchCoach();
        this.fetchData();
    },
    methods: {
        handleReset() {
            const today = new Date();
            const begin = today.setTime(today.getTime() - 3600 * 1000 * 24 * 31);
            this.date = [begin, new Date()];
            this.form = {
                storeId: '',
                coachId: '',
            };
            this.fetchData(1);
        },
        fetchData(page = null) {
            if (page) this.pagination.page = page;

            if (this.date.length) {
                this.form.dateFrom = new Date(this.date[0]).format('YYYY-MM-DD');
                this.form.dateTo = new Date(this.date[1]).format('YYYY-MM-DD');
            } else {
                this.form.dateFrom = null;
                this.form.dateTo = null;
            }
            API.get('statistic/coach-schedule/pages', {
                params: {...this.form, ...this.pagination},
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                this.$emit('handleForm', this.form);
            }).finally(() => {
                this.loading = false;
            });
        },
        fetchStore() {
            API.get('store/list').then(res => {
                this.stores = res;
            });
        },
        fetchCoach() {
            API.get('staff/list', {
                params: {
                    option: 'and',
                    roleIds: [7, 8],
                }
            }).then(res => {
                this.coachs = res;
            });
        }
    },
};
</script>
<style lang="scss">
.trainer-course-select {
    padding: 0 0 15px 0;
    border-bottom: 1px solid #e9e9e9;
    .el-select {
        margin-right: 0.5rem;
    }
    .el-button {
        margin-left: 0.5rem;
    }
}
.trainer-course-tip {
    float: right;
    padding: 15px 0;
    font-size: 12px;
}
</style>
